<template>
    <b-form id="data_submit" @submit="onSubmit">
        <div class="row">
            <div class="col-sm-12">
                <b-form-group label="Дата"
                              label-for="title">
                    <datepicker input-class="form-control"
                                class="date"
                                :language="ru"
                                :disabledDates="disabledDates"
                                v-model="form.item.date"
                                placeholder=""/>
                    <span class="alert-danger" v-if="submitted && !form.item.date">Внесите дату</span>
                </b-form-group>
                <b-form-group label="Оффер">
                    <v-select :options="options" :filterable="false"
                              v-model="form.item.offer_id"
                              @search="onSearch">
                        <template slot="no-options">
                            Введите символы...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                ({{ option.id }})
                                {{ option.title }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                ({{ option.id ? option.id : option.label }})
                                {{ option.title ? option.title : form.item.offer.title }}
                            </div>
                        </template>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !form.item.offer_id">Выберите оффер</span>
                </b-form-group>
                <b-form-group label="Приложение" v-if="this.$currentUser.department === 'adkey'">
                  <b-form-select
                    required
                    size="sm"
                    :options="applicationOwnerOptions"
                    v-model="form.item.application_owner"
                  >
                  </b-form-select>
                  <span class=" alert-danger" v-if="submitted && !form.item.application_owner">Приложение</span>
                </b-form-group>
                <b-form-group label="ID партнёра">
                    <b-form-input class="insertInput"
                                  type="number"
                                  v-model="form.item.partner_id">
                    </b-form-input>
                    <span class=" alert-danger" v-if="submitted && !form.item.partner_id">ID партнёра</span>
                </b-form-group>


                <div class="row">
                    <div class="col-sm-6">
                        <b-form-group label="Subid-1">
                            <b-form-input class="insertInput"
                                          type="text"
                                          v-model="form.item.sub1">
                            </b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-sm-6">
                        <b-form-group label="Subid-2">
                            <b-form-input class="insertInput"
                                          type="text"
                                          v-model="form.item.sub2">
                            </b-form-input>
                        </b-form-group>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <b-form-group label="Subid-3">
                            <b-form-input class="insertInput"
                                          type="text"
                                          v-model="form.item.sub3">
                            </b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-sm-6">
                        <b-form-group label="Subid-4">
                            <b-form-input class="insertInput"
                                          type="text"
                                          v-model="form.item.sub4">
                            </b-form-input>
                        </b-form-group>
                    </div>
                </div>

                <b-form-group label="Источник">
                    <v-select :options="sourcesOptions" :filterable="false"
                              v-model="form.item.source_id"
                              @search="onSourcesSearch">
                        <template slot="no-options">
                            Введите символы...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.id }}
                                {{ option.title }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                ({{ option.id ? option.id : option.label }})
                                {{ option.title ? option.title : form.item.source.title }}
                            </div>
                        </template>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !form.item.source_id">Выберите источник</span>
                </b-form-group>
            </div>
            <div class="col-sm-6">
                <b-form-group label="Расход">
                    <b-form-input class="insertInput"
                                  type="number"
                                  step="any"
                                  v-model="form.item.expense">
                    </b-form-input>
                    <span class=" alert-danger" v-if="submitted && !form.item.expense">Введите расход</span>
                </b-form-group>
            </div>
            <div class="col-sm-6">
                <b-form-group label="Валюта расхода">
                    <v-select :options="currency"
                              v-model="form.item.expense_currency">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger"
                          v-if="submitted && !form.item.expense_currency">Выберите валюту расхода</span>
                </b-form-group>
            </div>
            <div class="col-sm-12">
                <b-form-group label="Ставка партнера">
                    <b-form-input class="insertInput"
                                  type="text"
                                  v-model="form.item.partners_rate">
                    </b-form-input>
                </b-form-group>
            </div>
            <div class="col-sm-12">
                <b-form-group label="Лиды">
                    <b-form-input
                            type="number"
                            v-model="form.item.leads_count">
                    </b-form-input>
                    <span class=" alert-danger"
                          v-if="submitted && !form.item.leads_count">Введите количество лидов</span>
                </b-form-group>
            </div>
            <div class="col-sm-6">
                <b-form-group label="Ставка">
                    <b-form-input class="insertInput"
                                  type="number"
                                  step="any"
                                  v-model="form.item.lead_rate">
                    </b-form-input>
                    <span class=" alert-danger" v-if="submitted && !form.item.lead_rate">Введите ставку.</span>
                </b-form-group>
            </div>
            <div class="col-sm-6">
                <b-form-group label="Валюта ставки">
                    <v-select :options="currency"
                              v-model="form.item.lead_currency">
                        <span slot="no-options">Совпадений не найдено.</span>
                    </v-select>
                    <span class=" alert-danger" v-if="submitted && !form.item.lead_currency">Введите валюту ставки.</span>
                </b-form-group>
            </div>
            <div class="col-sm-6">
                <b-form-group label="Скидка,%">
                    <b-form-input
                            max="100"
                            type="number"
                            step="any"
                            v-model="form.item.discount">
                    </b-form-input>
                </b-form-group>
            </div>
            <div class="col-sm-6">
                <b-form-group label="Тест">
                    <b-form-checkbox v-model="form.item.is_test"
                                     value="1"
                                     unchecked-value="0" name="check-button">
                    </b-form-checkbox>
                </b-form-group>
            </div>
            <div class="col-sm-12">
                <b-button type="submit" class="float-right"
                          variant="primary">Сохранить и выйти
                </b-button>
            </div>
        </div>

        <div class="form-errors"></div>
    </b-form>
</template>
<script>
    import OffersService from '../../../services/offersDataService'
    import SourcesService from '../../../services/sourcesDataService'
    import Datepicker from 'vuejs-datepicker'
    import DataService from '../../../services/dataDataService'
    import {ru} from '../../../services/customLocaleDatepicker'

    export default {
        name: 'EditDataModal',
        components: {
            OffersService: OffersService,
            Datepicker: Datepicker
        },
        props: {
            form: {
                default: function () {
                    return {
                        date: new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1)),
                        offer_id: '',
                        application_owner: null,
                        sub1: '',
                        sub2: '',
                        sub3: '',
                        sub4: '',
                        source_id: '',
                        expense: '',
                        expense_currency: '',
                        partners_rate: '',
                        leads_count: '',
                        lead_rate: '',
                        lead_currency: '',
                        partner_id: '',
                        discount: 0,
                        is_test: 0
                    }
                }
            },
          applicationOwnerOptions: []
        },
        data() {
            return {
                currency: [],
                sourcesOptions: [],
                options: [],
                submitted: false,
                ru: ru,
                disabledDates: {
                    ranges: [{
                        from: new Date(1970, 1, 1),
                        to: new Date(this.$editDate)
                    }]
                },
            }
        },
        methods: {
            onSubmit(evt) {
                evt.preventDefault();
                this.submitted = true;

                if (!this.form.item.date || !this.form.item.offer_id || !this.form.item.source_id || !this.form.item.expense || !this.form.item.expense_currency || !this.form.item.leads_count || !this.form.item.lead_rate || !this.form.item.lead_currency || !this.form.item.partner_id) {
                    // evt.preventDefault();

                    return;
                }

                DataService.update(this.form.item)
                    .then(function (response) {
                        this.$bvModal.hide('dataEditModal')
                    }.bind(this))
            },
            getCurrency() {
                OffersService.getCurrency()
                    .then(function (response) {

                        this.currency = response;
                    }.bind(this))
            },
            onSearch(search, loading) {
                if (!search) {

                    return;
                }
                loading(true);

                let sort = {
                    sortBy: 'created_at',
                    sortDesc: true,
                }

                let range = {
                    start: null,
                    end: null
                }
                let user = null;

                OffersService.getDataSelectOffers(1, sort, search, range, user)
                    .then(function (response) {
                        let options = [];
                        response.forEach(function (element) {
                            element.label = '';
                            options.push(element)
                        });
                        this.options = options;
                        loading(false);
                    }.bind(this), 350)
            },
            onSourcesSearch(search, loading) {
                if (!search) {

                    return;
                }
                loading(true);

                let sort = {
                    sortBy: 'created_at',
                    sortDesc: true,
                }

                let range = {
                    start: null,
                    end: null
                }
                let user = null;

                SourcesService.getSources(1, sort, search, range, user)
                    .then(function (response) {
                        let options = [];
                        response.data.forEach(function (element) {
                            element.label = '';
                            options.push(element)
                        });
                        this.sourcesOptions = options;
                        loading(false);
                    }.bind(this), 350)
            }
        },
        beforeMount() {
            this.getCurrency();
        }
    }
</script>
<style>
    .vdp-datepicker input {
        background-color: white !important;
    }
</style>



// WEBPACK FOOTER //
// resources/js/views/front/modals/EditDataModal.vue